import { render, staticRenderFns } from "./closeMdfeTips.vue?vue&type=template&id=a3edabaa"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3edabaa')) {
      api.createRecord('a3edabaa', component.options)
    } else {
      api.reload('a3edabaa', component.options)
    }
    module.hot.accept("./closeMdfeTips.vue?vue&type=template&id=a3edabaa", function () {
      api.rerender('a3edabaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoiceCenter/mdfe/cmp/closeMdfeTips.vue"
export default component.exports